import { useAccountSelector } from 'src/hooks';
import { MCollapse, MTypography } from 'src/lib';
import { Color, Spacing } from 'src/styles';

import { OtherAccountHolderMailingAddressSection } from './OtherAccountHolderMailingAddressSection';
import { OtherAccountHolderSection } from './OtherAccountHolderSection';
import { OtherAccountHolderPhysicalAddressSection } from './OtherAccountPhysicalAddressSection';

export const OtherAccountHolderListSection = () => {
  const { account } = useAccountSelector();

  const getOptionList = () => {
    return (
      account?.otherAccountHolders?.map((holder, index) => ({
        id: holder.id,
        header: `Authorized Signer ${index + 3}`,
        content: (
          <>
            <OtherAccountHolderSection accountHolder={holder} />
            <OtherAccountHolderPhysicalAddressSection accountHolder={holder} />
            <OtherAccountHolderMailingAddressSection accountHolder={holder} />
          </>
        ),
      })) || []
    );
  };

  const findDefaultActiveKey = () => {
    return account?.otherAccountHolders && account.otherAccountHolders?.length > 0
      ? account?.otherAccountHolders[0].id
      : undefined;
  };

  return (
    <>
      <MTypography
        variant='h4'
        weight='normal'
        color={Color.Brand6}
        className={Spacing.my32}
        testId='other-account-holder-list-section'>
        Other Authorized Signers
      </MTypography>
      <MCollapse defaultActiveKey={findDefaultActiveKey()} optionList={getOptionList()} />{' '}
    </>
  );
};
